import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, TrendingDown, Activity } from 'lucide-react';

const StatCard = ({ title, value, icon: Icon, color, change, loading = false }) => {
  const isPositive = change && change > 0;
  const isNegative = change && change < 0;
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white overflow-hidden rounded-lg shadow-sm border border-gray-200"
    >
      <div className="p-5">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <Icon className={`h-6 w-6 ${color}`} />
          </div>
          <div className="ml-5 w-0 flex-1">
            <dl>
              <dt className="text-sm font-medium text-gray-500 truncate">
                {title}
              </dt>
              <dd className="text-lg font-medium text-gray-900">
                {loading ? (
                  <div className="animate-pulse h-6 bg-gray-200 rounded"></div>
                ) : (
                  value
                )}
              </dd>
            </dl>
          </div>
        </div>
        {change !== undefined && change !== null && !loading && (
          <div className="mt-3">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                {isPositive ? (
                  <TrendingUp className="h-4 w-4 text-green-500" />
                ) : isNegative ? (
                  <TrendingDown className="h-4 w-4 text-red-500" />
                ) : (
                  <Activity className="h-4 w-4 text-gray-500" />
                )}
              </div>
              <div className={`ml-1 text-sm ${isPositive ? 'text-green-600' : isNegative ? 'text-red-600' : 'text-gray-600'}`}>
                {isPositive ? '+' : ''}{change} this week
              </div>
            </div>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default StatCard;
